<div class="mt-2 p-2 border rounded">
  <div class="row">
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsWBSColumnsVisible"
          [(ngModel)]="variables['IsWBSColumnsVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsWBSColumnsVisible">WBS Columns Visible</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsWeightPerUnitVisible"
          [(ngModel)]="variables['IsWeightPerUnitVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsWeightPerUnitVisible">Weight Per Unit Visible</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsComment2Visible"
          [(ngModel)]="variables['IsComment2Visible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsComment2Visible">Comment 2 Visible</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsOutEngOriginVisible"
          [(ngModel)]="variables['IsOutEngOriginVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsOutEngOriginVisible">Out Eng Origin Visible</label>
      </div>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsICEngOriginVisible"
          [(ngModel)]="variables['IsICEngOriginVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsICEngOriginVisible">IC Eng Origin Visible</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsExternalSuppliesColumnsVisible"
          [(ngModel)]="variables['IsExternalSuppliesColumnsVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsExternalSuppliesColumnsVisible">External Supplies Columns Visible</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsIntraSuppliesOriginVisible"
          [(ngModel)]="variables['IsIntraSuppliesOriginVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsIntraSuppliesOriginVisible">Intra Supplies Origin Visible</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsMcSurchargesColumnsVisible"
          [(ngModel)]="variables['IsMcSurchargesColumnsVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsMcSurchargesColumnsVisible">MC Surcharges Columns Visible</label>
      </div>
    </div>
  </div>
</div>
